<template>

  <div class=''>

    <div class='title'>
        <div class="form_flex" v-if="windowWidth > 1120">
          <div @click="changetopIndex(0)" class="top_btn_box" :class="topindex == 0 ? 'border_top_box' : ''">All</div>
          <div @click="changetopIndex(3)" class="top_btn_box" :class="topindex == 3 ? 'border_top_box' : ''">Carbon Neutrality</div>
          <div @click="changetopIndex(1)" class="top_btn_box" :class="topindex == 1 ? 'border_top_box' : ''">Digital Life Design 2022</div>
          <div @click="changetopIndex(2)" class="top_btn_box" :class="topindex == 2 ? 'border_top_box' : ''">World Economic Forum 2022</div>
          
        </div>
        <div v-else class="form_iphon_box">
          <el-select v-model="topindex" :popper-append-to-body="false" @change="changetopindex(topindex)" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
    </div>

    <div class="list_box" id="listcard">
      <div style="padding:8px" v-for="(item,index) in tokenList" :key="index">
        <div :style="{width:divwidth+'px',height:divheight+'px'}" @click="gotoshop(item.sn)" class="card_box list_animation_box">
          <!-- <div class="tlbtn_box" @click="changeboard(item)">
              <img src="../../assets/img/kongxin.png" v-show="!item.board" alt="">
              <img src="../../assets/img/shixin.png" v-show="item.board" alt="">
              <span>{{item.sum}}</span>
          </div> -->
          <div :style="{width:(divwidth-20)+'px',height:(divwidth-15)+'px'}" v-loading="loading" class="img_card">
            <img v-if="imageURI && item.operationName == 'World Economic Forum 2022'" :src='imageURI' @load="changeloading(imageURI)" style="width:auto;height:auto;max-width: 100%;max-height: 100%;" alt="">
            <img v-if="imageURID && item.operationName == 'Digital Life Design 2022'" :src='imageURID' @load="changeloading(imageURID)" style="width:auto;height:auto;max-width: 100%;max-height: 100%;" alt="">
            <img v-if="imageURIO && item.operationName == 'Carbon Neutrality'" :src='imageURIO' @load="changeloading(imageURIO)" style="width:auto;height:auto;max-width: 100%;max-height: 100%;" alt="">
            <el-image v-if="!imageURI">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div class="position_box">
              <div class="margin_box">{{item.nickName}}</div>
              <div >{{item.description}}</div>
            </div>
          </div>
          <div class="data_box">
            <div class="flex_box">
              <div class="font_img">
                
                <p v-if="item.operationName == 'Carbon Neutrality'">{{ item.operationName }}</p>
                <p v-else>Carbon Neutral For {{ item.operationName }}</p>
                <!-- <img src="../../assets/img/huaban.png" class="img_box" alt=""> -->
              </div>
              <!-- <div>
                <p>Price</p>
              </div> -->
            </div>
            <div class="flex_box" >
              <span class="flex_span">{{ item.name }}</span>
              <!-- <span style="display:flex" v-if="item.operationName !== 'Carbon Neutrality'">US$ <p class="flex_p">35.00</p></span> -->
            </div>
          </div>
        </div>
      </div>

        <div class="empty_box" v-if="tokenList.length==0">
            <p>
                <img src="../../assets/img/nodata.png" alt="">
            </p>
            
            <p>{{$t('commodity.title')}}</p>
        </div>


    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import {mapState} from "vuex";
import nft from '@/api/nftgallery.js'

var elementResizeDetectorMaker = require("element-resize-detector")
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      formdata: {
        currency: 'All',
        sortBy: ''
      },
      divwidth: '',
      divheight: '',
      options:[
        {
          value:0,
          label:'All'
        },
        {
          value:1,
          label:'Digital Life Design 2022'
        },
        {
          value:2,
          label:'World Economic Forum 2022'
        },
        {
          value:3,
          label:'Carbon Neutrality'
        },
      ],
      imageURI:require('../../assets/img/nftimg.png'),
      imageURID:require('../../assets/img/digital.png'),
      imageURIO:require('../../assets/img/MVGX-CNC-2022.jpeg'),
      tokenList:[],
      topindex:0,
      loading: true,
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapState({
    })
  },
  // 监控data中的数据变化
  watch: {
      windowWidth (val) {
        console.log(123123,val)
        let that = this;
        this.windowWidth = val
      },
  },
  // 方法集合
  methods: {
    changetopIndex(index){
        this.topindex = index
        this.getlist()
    },
    changeboard(item) {
      item.board = !item.board
      if (item.board) {
        item.sum = item.sum + 1
      } else {
        item.sum = item.sum - 1
      }
    },
    gotoshop(id) {

      // 逻辑跳转路由，勿删！！！
      this.$router.push({path: '/nftcommodity',query: {sn:id}})
    },
    changedivWidth() {
      let that = this
      var erd = elementResizeDetectorMaker()
      erd.listenTo(document.getElementById("listcard"), function (element) {
        var width = element.offsetWidth - 60
        var height = element.offsetHeight
        that.$nextTick(function () {
          if (width > 2400 && width <= 2600) {
            that.divwidth = (width / 9) - 16
            that.divheight = that.divwidth * 1.27
          }
          if (width > 2100 && width <= 2400) {
            that.divwidth = (width / 8) - 16
            that.divheight = that.divwidth * 1.27
          }
          if (width > 1900 && width <= 2100) {
            that.divwidth = (width / 7) - 16
            that.divheight = that.divwidth * 1.27
          }
          if (width > 1600 && width <= 1900) {
            that.divwidth = (width / 6) - 16
            that.divheight = that.divwidth * 1.27
          }
          if (width > 1366 && width <= 1600) {
            that.divwidth = (width / 5) - 16
            that.divheight = that.divwidth * 1.27
          }
          if (width > 1000 && width <= 1366) {
            that.divwidth = (width / 4) - 16
            that.divheight = that.divwidth * 1.27
          }
          if (width > 700 && width <= 1000) {
            that.divwidth = (width / 3) - 16
            that.divheight = that.divwidth * 1.27
          }
          if (width > 450 && width <= 700) {
            that.divwidth = (width / 2) - 16
            that.divheight = that.divwidth * 1.27
          }
          if (width <= 450) {
            that.divwidth = (width / 1) - 16
            that.divheight = that.divwidth * 1.27
          }
          if (width > 2600) {
            that.divwidth = 290
            that.divheight = 366
          }
        })
      })
    },
    changeloading(src){
      let img = new Image()
      img.src = src
      let self = this
      img.onload = (()=>{
        self.loading = false
      })
    },
    changetopindex(val){
      console.log(val)
      this.topindex = val
      this.getlist()
    },
    //获取列表
    getlist(){
      let params = {
        captureStatus:2,
        operationStatus:this.topindex
      }
      nft.getlist(response =>{
        console.log(response)
        if(response.list){
          this.tokenList = response.list
        }
      },params)
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // this.$store.dispatch("nft/getTokenList", this.formdata);
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.changedivWidth();
    this.getlist()
    window.onresize = () => {
        return (() => {
            window.fullWidth = document.documentElement.clientWidth;
            this.windowWidth = window.fullWidth; // 宽
        })()
    }
  },
  beforeCreate() {
  }, // 生命周期 - 创建之前
  beforeMount() {
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
  }, // 生命周期 - 更新之前
  updated() {
  }, // 生命周期 - 更新之后
  beforeDestroy() {
  }, // 生命周期 - 销毁之前
  destroyed() {
  }, // 生命周期 - 销毁完成
  activated() {
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.new_box{
    height:420px;
    background: url('../../assets/img/btcbj.png') no-repeat;
    background-size: cover;
    font-size:16px;
    color:#7d91aa;
}
::v-deep .el-breadcrumb__inner{
        color:#C8C8C8 !important;
        font-size:16px !important;
    }
.sp{
    padding-top:90px;
    padding-bottom:90px;
    .el-row{
        margin-top:15%;
    }
    .col_list{
        padding:10px;
        margin-bottom:20px;
    }
}
.showtitle {
    color: #fff!important;
    line-height: 50px;
    font-size:40px;
    text-align: center;
}
.title {
//   width: 100%;
    height: 90px;
    margin: 40px 34px 0 34px;
    padding: 0;
    background: #F9F9F9;
    border-radius: 10px;
    display: flex;

}

::v-deep input[type="text"], select, textarea {
  border: 1px solid #EBEEF2 !important;
}

.form_iphon_box{
  display: flex;
  align-items: center;
  margin: 0 auto;
}

.form_flex {
    height: 100%;
    display: flex;
    align-items: center;
    .top_btn_box{
        margin-left: 30px;
        padding: 11px 35px;
        border-radius: 4px;
        border: 1px solid #E7EAED;
        text-align: center;
        cursor: pointer;
        font-size: 18px;
        font-family: ArialMT;
        color: #8F8F8F;
        line-height: 21px;
    }
    .border_top_box{
        background: #158869;
        border-radius: 4px;
        color: #FFFFFF;
    }
}

.empty_box{
  margin: 0 auto;
  padding-top:120px;
  p{
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5D5D5D;
    line-height: 18px;
  }
}


.img-box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.btn_box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0 auto;
  padding: 30px 0 30px 0;
  text-align: center;

  .el-button {
    padding: 12px 40px;
    background: #2181E2;
    font-family: Arial-BoldMT, Arial;
    font-weight: normal;
    color: #FFFFFF;
  }

  .sumdata_box {
    width: 554px;
    height: 82px;
    border: 1px solid #F4F7FA;
    text-align: center;
    margin: 0 auto;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;

    .sum_box {
      width: 25%;
      padding-top: 12px;

      h4 {
        font-size: 24px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #353840;
      }

      p {
        font-size: 14px;
        font-family: ArialMT;
        color: #8A949C;
      }
    }

    .sum_border {
      border-right: 1px solid #F4F7FA;
    }
  }
}

.list_animation_box {
  transition: all .6s;
}

.list_animation_box:hover {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02), 0 16px 32px -4px rgba(0, 0, 0, 0.17);
  transform: translateY(-1px);
}

// ::v-deep .el-icon-arrow-up:before {
  // content: url("../../assets/img/selectbe.png") !important;
// }

.list_box {
  min-height: 600px;
  padding: 30px;
  display: flex;
  flex-wrap: wrap;

  .card_box {
    // width: 293px;
    // height: 400px;
    padding: 9px 9px 0 9px;
    border: 1px solid #E7EAED;
    border-radius: 4px;
    position: relative;
    // margin:0 15px 15px 0;
    .tlbtn_box {
      position: absolute;
      top: 5px;
      right: 15px;

      span {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8A949C;
        margin-left: 7px;
        line-height: 17px;
      }

    }

    .img_card {
      // height: 285px;
      background: #F5F5F5;
      border: 1px solid #F5F5F5;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding:10px 0;
      margin: 0 auto;
      position: relative;
      .position_box{
        position: absolute;
        text-align: center;
        top: auto;
        bottom: auto;
        left: auto;
        right: auto;
        .margin_box{
          font-weight: 600;
          margin-bottom: 5px;
        }
        div{
          width: 98px;
          max-width: 98px;
          font-size: 12px;
          *font-size: 10px;
          font-family: Gotham-Book, Gotham;
          font-weight: normal;
          color: #303236;
          line-height: 15px !important;
        }
      }
    }

    .data_box {
      padding: 15px 5px 0px 5px;

      .flex_box {
        display: flex;
        justify-content: space-between;
        // padding: 5px 0;

        .font_img {
          position: relative;
          padding-right: 15px;
          width: 100%;
          p{
            width: 100%;
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .img_box {
            position: absolute;
            right: 0;
            top: 2px;
          }
        }

        p {
          font-size: 12px;
          font-family: ArialMT;
          color: #8A949C;
          line-height: 14px;
        }

        span {
            font-size: 12px;
            font-family: ArialMT;
            color: #8A949C;
            line-height: 14px;
        }
        .flex_span{
            font-size: 14px;
            font-family: ArialMT;
            color: #161616;
            line-height: 16px;
        }

        .flex_p {
            margin-left: 5px;
            font-size: 16px;
            font-family: Arial-BoldMT, Arial;
            font-weight: normal;
            color: #000000;
            line-height: 18px;
            transform: translateY(-1px);
        }
      }
    }
  }
}

::v-deep .el-scrollbar{
  .el-scrollbar__bar{
    opacity: 1 !important;
  }
} 

// @media screen and (min-width: 1600px) {
//   .title{
//     // width: 85%;
//     margin: 40px 34px 40px 34px;
//     background: #F9F9F9;
//     height: 90px;
//     padding: 0;
//     background: #F9F9F9;
//     border-radius: 10px;
//     .img-div{
//       width: 85%;
//       margin: 0 auto;
//       padding: 0;
//     }
//   }
//   .list_box{
//     width: 83%;
//     margin: 0 auto;
//   }
  
// }
</style>
